var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:['switch']},[_c('input',{class:['switch2', _vm.state, _vm.variation, _vm.checked],attrs:{"id":_vm.id,"type":"checkbox","disabled":_vm.disabled,"name":_vm.name},domProps:{"checked":_vm.value},on:{"input":_vm.handleInput}}),_vm._v(" "),_c('i'),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }